import * as React from "react";
import { Divider, Flex, Text } from "@chakra-ui/react";
import { AccordionItem, Form } from "components";
import { useCurrentCase } from "duck";
import {
  BoneLoss,
  FileInput,
  AdditionalPhotos,
  RadiographicFindings
} from "./components";
import { useUpdatePhotos, FormValues, getDefaultValues } from "./duck";

const Photos: React.FC = () => {
  const { generalAssessment, milkOrAdultTeeth } = useCurrentCase(medCase => ({
    generalAssessment: medCase.data.client.patient.generalAssessment,
    milkOrAdultTeeth:
      medCase.data.client.patient.generalAssessment?.dentalChart || null
  }));

  const defaultValues = getDefaultValues(generalAssessment);
  const onChange = useUpdatePhotos();

  return (
    <AccordionItem title="Imaging">
      <Form<FormValues> defaultValues={defaultValues}>
        <Form.Watcher defaultValues={defaultValues} onChange={onChange} />

        <Flex direction="column" rowGap="4">
          <Text fontWeight="semibold" color="gray.600">
            Before
          </Text>
          <Flex direction={{ base: "column", sm: "row" }} gridGap="6">
            <FileInput label="Right" name="beforePhotoRight" />
            <FileInput label="Front" name="beforePhotoFront" />
            <FileInput label="Left" name="beforePhotoLeft" />
          </Flex>
        </Flex>

        <Divider my={6} h="1px" borderColor="#D0D1D3" />

        <Flex direction="column" rowGap="4">
          <Text fontWeight="semibold" color="gray.600">
            After
          </Text>
          <Flex direction={{ base: "column", sm: "row" }} gridGap="6">
            <FileInput label="Right" name="afterPhotoRight" />
            <FileInput label="Front" name="afterPhotoFront" />
            <FileInput label="Left" name="afterPhotoLeft" />
          </Flex>
        </Flex>

        <Divider my={6} h="1px" borderColor="#D0D1D3" />

        <AdditionalPhotos />

        <Divider my={6} h="1px" borderColor="#D0D1D3" />

        <RadiographicFindings />
      </Form>

      {milkOrAdultTeeth && <BoneLoss />}
    </AccordionItem>
  );
};

export default Photos;
